export default "__VITE_ASSET__asscRJ4x__"